import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the IngredientViewGraphicsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-view-graphics',
    templateUrl: 'ingredient-view-graphics.html',
})
export class IngredientViewGraphicsPage {
    @Input() ingredient: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams
    ) {
    }

}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-view/ingredient-view-graphics/ingredient-view-graphics.ts